class Rolodex extends HTMLElement {
  connectedCallback() {
    this._links = Array.from(this.querySelectorAll('.rolodex__nav-link'));
    this._track = this.querySelector('.rolodex__track');
    this._viewport = this.querySelector('.rolodex__viewport');

    if (!this._track || !this._links.length) return;

    const found = this._links.findIndex((l) => l.classList.contains('[data-active="true"]'));
    this._activeIndex = found >= 0 ? found : 0;

    this._controller = new AbortController();
    const { signal } = this._controller;

    const onDelegate = (e) => {
      const link = e.target.closest('.rolodex__nav-link');
      if (!link) return;
      const index = this._links.indexOf(link);
      if (index !== -1) this._activate(index);
    };

    this.addEventListener('mouseover', onDelegate, { signal });
    this.addEventListener('focusin', onDelegate, { signal });

    this._resizeObserver = new ResizeObserver(() =>
      this._activate(this._activeIndex, { immediate: true })
    );
    this._resizeObserver.observe(this._viewport);

    this._activate(this._activeIndex, { immediate: true });
  }

  disconnectedCallback() {
    this._controller?.abort();
    this._resizeObserver?.disconnect();
  }

  _activate(index, { immediate = false } = {}) {
    if (!immediate && index === this._activeIndex) return;
    this._activeIndex = index;

    this._links.forEach((link, i) => (link.dataset.active = String(i === index)));

    const rowGap = parseFloat(getComputedStyle(this._track).rowGap) || 0;
    const offset = index * (this._viewport.offsetHeight + rowGap);

    if (immediate) {
      this._track.style.transitionDuration = '0s';
    }
    this._track.style.transform = `translateY(-${offset}px)`;
    if (immediate) {
      this._track.offsetHeight; // force reflow before re-enabling transition
      this._track.style.transitionDuration = '';
    }
  }
}

customElements.define('chh-rolodex', Rolodex);

export default Rolodex;
